import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient, { StudioGuide } from "api/admin";
import { STUDIO_GUIDES_QUERY_KEY } from "./useStudioGuides";

const useSaveStudioGuides = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (items: StudioGuide[]) =>
      adminApiClient.saveStudioGuides(items),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [STUDIO_GUIDES_QUERY_KEY] });
    },
  });
};

export default useSaveStudioGuides;
